export const projelerData = [
    {
        title: {
            tr: 'Konut Projeleri',
            en: 'Residential Projects'
        },
        link: 'konut-projeleri',
        categoryItem: [
            {
                title: {
                    tr: 'AY IŞIĞI İNŞAAT - AHMET SELVİ İNŞAAT  SELVİ REZIDANS',
                    en: 'AY IŞIĞI İNŞAAT - AHMET SELVİ İNŞAAT  SELVİ REZİDANS'
                },
                link: 'ay-isigi-insaat-ahmet-selvi-insaat-selvi-rezidans',
                systems: [
                    'sac-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4', '5'],
            },
            {
                title: {
                    tr: 'AYHAN AKSU - AĞAOĞLU MY WORLD PROJESİ',
                    en: 'AYHAN AKSU - AĞAOĞLU MY WORLD PROJECT'
                },
                link: 'ayhan-aksu-agaoglu-my-world-projesi',
                systems: [
                    'sac-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4'],
            },
            {
                title: {
                    tr: 'AYHAN AKSU - MİLAS DAPHNE PROJESİ - MİLAS',
                    en: 'AYHAN AKSU - MİLAS DAPHNE PROJECT - MİLAS'
                },
                link: 'ayhan-aksu-milas-daphne-projesi-milas',
                systems: [
                    'dairesel-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4', '5'],
            },
            {
                title: {
                    tr: 'BATI İNŞAAT - SU SESİ TERMAL OTEL - GERMENCİK',
                    en: 'BATI İNŞAAT - SU SESİ THERMAL HOTEL - GERMENCİK'
                },
                link: 'bati-insaat-su-sesi-termal-otel-germencik',
                systems: [
                    'askerli-celik-kalip-sistemi',
                    'merdiven-kaliplari'
                ],
                img: ['1', '2', '3', '4', '5','6','7','8'],
            },
            {
                title: {
                    tr: 'FATİH İNŞAAT - VADİ İSTANBUL PROJESİ - İSTANBUL',
                    en: 'FATİH İNŞAAT - VADİ İSTANBUL PROJECT - İSTANBUL'
                },
                link: 'fatih-insaat-vadi-istanbul-projesi-istanbul',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4', '5','6'],
            },
            {
                title: {
                    tr: 'GEREDELİ İNŞAAT - TRIO TOWERS - ZONGULDAK',
                    en: 'GEREDELİ İNŞAAT - TRIO TOWERS - ZONGULDAK'
                },
                link: 'geredeli-insaat-trio-towers-zonguldak',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4', '5','6'],
            },
            {
                title: {
                    tr: 'KSC YAPI - ALACITY PROJESİ - ALAŞEHİR',
                    en: 'KSC YAPI - ALACITY PROJECT - ALAŞEHİR'
                },
                link: 'ksc-yapi-alacity-projesi-alasehir',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4','5'],
            },
            {
                title: {
                    tr: 'KUMKO YAPI - VARYANT KARŞIYAKA PROJESİ - İZMİR',
                    en: 'KUMKO YAPI - VARYANT KARŞIYAKA PROJECT - İZMİR'
                },
                link: 'kumko-yapi-varyant-karsiyaka-projesi-izmir',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4'],
            },
            {
                title: {
                    tr: 'NEVZAT USTA İNŞAAT - TOPKAPI 29 PROJESİ - İSTANBUL',
                    en: 'NEVZAT USTA İNŞAAT - TOPKAPI 29 PROJECT - İSTANBUL'
                },
                link: 'nevzat-usta-insaat-topkapi-29-projesi-istanbul',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4','5','6'],
            },
            {
                title: {
                    tr: 'ORKUM YAPI - 100. YIL ONUR EVLERİ - BURSA',
                    en: 'ORKUM YAPI - 100. YIL ONUR HOUSES - BURSA'
                },
                link: 'orkum-yapi-100-yil-onur-evleri-bursa',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4'],
            },
            {
                title: {
                    tr: 'ÖĞÜN İNŞAAT - CİNKAYA PRIME TOWERS - DENİZLİ',
                    en: 'ÖĞÜN İNŞAAT - CİNKAYA PRIME TOWERS - DENİZLİ'
                },
                link: 'ogun-insaat-cinkaya-prime-towers-denizli',
                systems: [
                    'dairesel-balkon-parapet-kaliplari',
                ],
                img: ['1', '2', '3', '4','5'],
            },
            {
                title: {
                    tr: 'ŞUA İNŞAAT - GREEN LAND VİLLARI - ERBİL',
                    en: 'ŞUA İNŞAAT - GREEN LAND VILLAS - ERBİL'
                },
                link: 'sua-insaat-green-land-villari-erbil',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                    'dairesel-balkon-parapet-kaliplari',
                ],
                img: ['1', '2', '3', '4','5','6'],
            },
            {
                title: {
                    tr: 'URHAN GAYRİMENKUL - FLORA PARK BOUTIQUE  PROJESİ - DENİZLİ',
                    en: 'URHAN GAYRİMENKUL - FLORA PARK BOUTIQUE  PROJECT - DENİZLİ'
                },
                link: 'urhan-gayrimenkul-flora-park-boutique-projesi-denizli',
                systems: [
                    'dairesel-balkon-parapet-kaliplari',
                ],
                img: ['1', '2', '3', '4','5','6','7','8','9'],
            },
            {
                title: {
                    tr: 'YILDIZLAR İNŞAAT - DOSSO DOSSİ RESIDENCE HALKALI PROJESİ - İSTANBUL',
                    en: 'YILDIZLAR İNŞAAT - DOSSO DOSSİ RESIDENCE HALKALI PROJECT - İSTANBUL'
                },
                link: 'yildizlar-insaat-dosso-dossi-residence-halkali-projesi-istanbul',
                systems: [
                       'dairesel-balkon-parapet-kaliplari',
                ],
                img: ['1', '2', '3'],
            },
        ]
    },
    {
        title: {
            tr: 'Gökdelen Projeleri',
            en: 'Skyscraper Projects'
        },
        link: 'gokdelen-projeleri',
        categoryItem: [
            {
                title: {
                    tr: 'ABB MÜHENDİSLİK - ELİTE CONCEPT - İSTANBUL',
                    en: 'ABB MÜHENDİSLİK - ELİTE CONCEPT - İSTANBUL'
                },
                link: 'abb-muhendislik-elite-concept-istanbul',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4', '5','6','7','8','9'],
            },
            {
                title: {
                    tr: 'AYHAN AKSU - MESA KOZ PROJESİ - İSTANBUL',
                    en: 'AYHAN AKSU - MESA KOZ PROJECT - İSTANBUL'
                },
                link: 'ayhan-aksu-mesa-koz-projesi-istanbul',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4', '5','6','7','8'],
            },
            {
                title: {
                    tr: 'FATİH İNŞAAT - SİNPAŞ AQUA CITY - DENİZLİ',
                    en: 'FATİH İNŞAAT - SİNPAŞ AQUA CITY - DENİZLİ'
                },
                link: 'fatih-insaat-sinpas-aqua-city-denizli',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4'],
            },
            {
                title: {
                    tr: 'GALİAWA GROUP - LONDON TOWERS - ERBİL',
                    en: 'GALİAWA GROUP - LONDON TOWERS - ERBİL'
                },
                link: 'galiawa-group-london-towers-erbil',
                systems: [
                    'dairesel-balkon-parapet-kaliplari',
                ],
                img: ['1', '2', '3', '4', '5','6','7'],
            },
            {
                title: {
                    tr: 'HARUN BÜYÜKDENİZ İNŞAAT - ANKA CADDE PROJESİ - ANKARA',
                    en: 'HARUN BÜYÜKDENİZ İNŞAAT - ANKA CADDE PROJECT - ANKARA'
                },
                link: 'harun-buyukdeniz-insaat-anka-cadde-projesi-ankara',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4', '5'],
            },
            {
                title: {
                    tr: 'KUMKO YAPI - VARYANT TOWER BORNOVA PROJESİ - İZMİR',
                    en: 'KUMKO YAPI - VARYANT TOWER BORNOVA PROJECT - İZMİR'
                },
                link: 'kumko-yapi-varyant-tower-bornova-projesi-izmir',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                    'scaf-fix-h-tipi-iskele-sistemi'
                ],
                img: ['1', '2', '3', '4', '5'],
            },
            {
                title: {
                    tr: 'KÜRK İNŞAAT - TULİP TOWERS - ERBİL',
                    en: 'KÜRK İNŞAAT - TULİP TOWERS - ERBİL'
                },
                link: 'kurk-insaat-tulip-towers-erbil',
                systems: [
                    'dairesel-balkon-parapet-kaliplari',
                ],
                img: ['1', '2', '3', '4','6','7','8','9','10','11','12'],
            },
            {
                title: {
                    tr: 'SUNRISE DEVELOPMENT - SUNRISE PALACE - BATUM',
                    en: 'SUNRISE DEVELOPMENT - SUNRISE PALACE - BATUM'
                },
                link: 'sunrise-development-sunrise-palace-batum',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4', '5','6','7'],
            },
            {
                title: {
                    tr: 'TBILISI GARDENS PROJECT - TİFLİS',
                    en: 'TBILISI GARDENS PROJECT - TİFLİS'
                },
                link: 'tbilisi-gardens-project-tiflis',
                systems: [
                    'dairesel-balkon-parapet-kaliplari',
                ],
                img: ['1', '2', '3', '4', '5','6'],
            },
        ]
    },
    {
        title: {
            tr: 'AVM, Hastane ve İş Merkezleri',
            en: 'Shopping Mall, Hospital and Business Center Projects'
        },
        link: 'avm-hastane-ve-is-merkezleri',
        categoryItem: [
            {
                title: {
                    tr: 'AYHAN AKSU - 262 TOWERS - İZMİT',
                    en: 'AYHAN AKSU - 262 TOWERS - İZMİT'
                },
                link: 'ayhan-aksu-262-towers-izmit',
                systems: [
                    'dairesel-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4', '5','6','7','8'],
            },
            {
                title: {
                    tr: 'AYHAN AKSU - ŞİMAL AVM - RİZE',
                    en: 'AYHAN AKSU - ŞİMAL SHOPPING MALL - RİZE'
                },
                link: 'ayhan-aksu-simal-avm-rize',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4', '5','6','7','8','9'],
            },
            {
                title: {
                    tr: 'AYHAN AKSU - TAKSİM ACIBADEM HASTANESİ PROJESİ',
                    en: 'AYHAN AKSU - TAKSİM ACIBADEM HOSPITAL PROJECT'
                },
                link: 'ayhan-aksu-taksim-acibadem-hastanesi-projesi',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4', '5'],
            },
        ]
    },
    {
        title: {
            tr: 'Sanayi Yapıları',
            en: 'Industrial Buildings'
        },
        link: 'sanayi-yapilari',
        categoryItem: [
            {
                title: {
                    tr: 'AYHAN AKSU - ETİ BAKIR FABRİKA PROJESİ - SAMSUN',
                    en: 'AYHAN AKSU - ETİ BAKIR FACTORY PROJECT - SAMSUN'
                },
                link: 'ayhan-aksu-eti-bakir-fabrika-projesi-samsun',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                    'gik-kamali-flansli-iskele-sistemi',
                ],
                img: ['1', '2', '3', '4', '5','6','7'],
            },
            {
                title: {
                    tr: 'AYHAN AKSU - ATAKLAR LOJİSTİK DEPO PROJESİ',
                    en: 'AYHAN AKSU - ATAKLAR LOGISTIC WAREHOUSE PROJECT'
                },
                link: 'ayhan-aksu-ataklar-lojistik-depo-projesi',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                    'kalip-alti-iskele-sistemi',
                ],
                img: ['1', '2', '3', '4', '5','6','7','8','9','10'],
            },
            {
                title: {
                    tr: 'EKİNOKS PROJE - ARSAN KAUÇUK FABRİKA PROJESİ - FERİZLİ',
                    en: 'EKİNOKS PROJE - ARSAN KAUÇUK FACTORY PROJECT - FERİZLİ'
                },
                link: 'ekinoks-proje-arsan-kaucuk-fabrika-projesi-ferizli',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                    'kalip-alti-iskele-sistemi',
                ],
                img: ['1', '2', '3', '4', '5','6','7','8','9','10','11','12'],
            },
            {
                title: {
                    tr: 'YAPIKAYA İNŞAAT - SÜRÜ TEKSTİL FAB. PROJESİ - DENİZLİ',
                    en: 'YAPIKAYA İNŞAAT - SÜRÜ TEKSTİL FACTORY PROJECT - DENİZLİ'
                },
                link: 'yapikaya-insaat-suru-tekstil-fab-projesi-denizli',
                systems: [
         'mo-kai-plywood-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4', '5','6','7','8'],
            },
        ]
    },
    {
        title: {
            tr: 'Endüstriyel Projeler',
            en: 'Industrial Projects'
        },
        link: 'endustriyel-projeler',
        categoryItem: [
            {
                title: {
                    tr: 'HÜSEYİN ÖZKAN - BİYOKÜTLE ENERJİ SANT. PROJESİ - KARAMAN',
                    en: 'HÜSEYİN ÖZKAN - BİYOKÜTLE ENERGY PLANT PROJECT - KARAMAN'
                },
                link: 'huseyin-ozkan-biyokutle-enerji-sant-projesi-karaman',
                systems: [
                    'mo-kai-plywood-yuzeyli-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4', '5'],
            },
        ]
    },
    {
        title: {
            tr: 'Alt Yapı Projeleri',
            en: 'Infrastructure Projects'
        },
        link: 'alt-yapi-projeleri',
        categoryItem: [
            {
                title: {
                    tr: 'AGA ENERJİ - BAKIRKÖY BAHÇELİEVLER KİRAZLI METRO PROJESİ - İSTANBUL',
                    en: 'AGA ENERJİ - BAKIRKÖY BAHÇELİEVLER KİRAZLI SUBWAY PROJECT - İSTANBUL'
                },
                link: 'aga-enerji-bakirkoy-bahcelievler-kirazli-metro-projesi-istanbul',
                systems: [
                    'saft-merdiveni-sistemi',
                ],
                img: ['1', '2', '3'],
            },
            {
                title: {
                    tr: 'AGA ENERJİ - İKİTELLİ ATAKÖY METRO PROJESİ - İSTANBUL',
                    en: 'AGA ENERJİ - İKİTELLİ ATAKÖY SUBWAY PROJECT - İSTANBUL'
                },
                link: 'aga-enerji-ikitelli-atakoy-metro-projesi-istanbul',
                systems: [
                    'saft-merdiveni-sistemi',
                ],
                img: ['1', '2', '3', '4'],
            },
            {
                title: {
                    tr: 'ALARKO - MECİDİYEKÖY MAHMUTBEY METRO PROJESİ - İSTANBUL',
                    en: 'ALARKO - MECİDİYEKÖY MAHMUTBEY SUBWAY PROJECT - İSTANBUL'
                },
                link: 'alarko-mecidiyekoy-mahmutbey-metro-projesi-istanbul',
                systems: [
                    'saft-merdiveni-sistemi',
                ],
                img: ['1', '2'],
            },
            {
                title: {
                    tr: 'ALARKO CENGİZ METRO ORT. - KAYNARCA PENDİK TUZLA METRO HATTI PROJESİ - İSTANBUL',
                    en: 'ALARKO CENGİZ METRO ORT. - KAYNARCA PENDİK TUZLA SUBWAY LINE PROJECT - İSTANBUL'
                },
                link: 'alarko-cengiz-metro-ort-kaynarca-pendik-tuzla-metro-hatti-projesi-istanbul',
                systems: [
                    'saft-merdiveni-sistemi',
                ],
                img: ['1', '2', '3'],
            },
            {
                title: {
                    tr: 'BEREKET ENERJİ - AKINCI HES PROJESİ - TOKAT',
                    en: 'BEREKET ENERJİ - AKINCI HYDRO ELECTRIC POWER PLANT PROJECT - TOKAT'
                },
                link: 'bereket-enerji-akinci-hes-projesi-tokat',
                systems: [
                    'saft-merdiveni-sistemi',
                ],
                img: ['1', '2', '3', '4', '5'],
            },
            {
                title: {
                    tr: 'GÜLERMAK-NUROL-MAKYOL - ÜMRANİYE ATAŞEHİR GÖZTEPE METRO PROJESİ - İSTANBUL',
                    en: 'GÜLERMAK-NUROL-MAKYOL - ÜMRANİYE ATAŞEHİR GÖZTEPE SUBWAY PROJECT - İSTANBUL'
                },
                link: 'gulermak-nurol-makyol-umraniye-atasehir-goztepe-metro-projesi-istanbul',
                systems: [
                    'saft-merdiveni-sistemi',
                ],
                img: ['1', '2', '3', '4', '5'],
            },
            {
                title: {
                    tr: 'İÇTAŞ - MAHMUTBEY BAHÇEŞEHİR ESENYURT METRO HATTI PROJESİ - İSTANBUL',
                    en: 'İÇTAŞ - MAHMUTBEY BAHÇEŞEHİR ESENYURT SUBWAY LINE PROJECT - İSTANBUL'
                },
                link: 'ictas-mahmutbey-bahcesehir-esenyurt-metro-hatti-projesi-istanbul',
                systems: [
                    'saft-merdiveni-sistemi',
                    'gemici-merdiveni-sistemi'
                ],
                img: ['1', '2', '3'],
            },
            {
                title: {
                    tr: 'KOLİN - KALYON -CENGİZ - GAYRETTEPE YENİ HAVALİMANI METRO PROJESİ - İSTANBUL',
                    en: 'KOLİN - KALYON -CENGİZ - GAYRETTEPE NEW AIRPORT SUBWAY PROJECT - İSTANBUL'
                },
                link: 'kolin-kalyon-cengiz-gayrettepe-yeni-havalimani-metro-projesi-istanbul',
                systems: [
                    'saft-merdiveni-sistemi',
                    'gemici-merdiveni-sistemi'
                ],
                img: ['1', '2', '3', '4', '5'],
            },
            {
                title: {
                    tr: 'KOLİN KALYON CENGİZ - HALKALI YENİ HAVALİMANI METRO PROJESİ - İSTANBUL',
                    en: 'KOLİN KALYON CENGİZ - HALKALI NEW AIRPORT SUBWAY PROJECT - İSTANBUL'
                },
                link: 'kolin-kalyon-cengiz-halkali-yeni-havalimani-metro-projesi-istanbul',
                systems: [
                    'saft-merdiveni-sistemi',
                    'gemici-merdiveni-sistemi'
                ],
                img: ['1', '2'],
            },
            {
                title: {
                    tr: 'THOR YAPI - GEYVE - DOĞANÇAY YHT PROJESİ',
                    en: 'THOR YAPI - GEYVE - DOĞANÇAY HIGH SPEED TRAIN PROJECT'
                },
                link: 'thor-yapi-geyve-dogancay-yht-projesi',
                systems: [
                    'dairesel-kalip-sistemi',
                    'kalip-alti-iskele-sistemi'
                ],
                img: ['1', '2', '3', '4', '5'],
            },
        ]
    },
    {
        title: {
            tr: 'Diğer Projeler',
            en: 'Other Projects'
        },
        link: 'diger-projeler',
        categoryItem: [
            {
                title: {
                    tr: 'AYHAN AKSU - BÜYÜK ÇAMLICA CAMİİ PROJESİ - İSTANBUL',
                    en: 'AYHAN AKSU - BÜYÜK ÇAMLICA MOSQUE PROJECT - İSTANBUL'
                },
                link: 'ayhan-aksu-buyuk-camlica-camii-projesi-istanbul',
                systems: [
                    'dairesel-kalip-sistemi',
                ],
                img: ['1', '2', '3', '4', '5'],
            },
            {
                title: {
                    tr: 'AYHAN AKSU - İZMİR ADNAN MENDERES HAVALİMANI PROJESİ',
                    en: 'AYHAN AKSU - İZMİR ADNAN MENDERES AIRPORT PROJECT'
                },
                link: 'ayhan-aksu-izmir-adnan-menderes-havalimani-projesi',
                systems: [
                    'dairesel-kalip-sistemi',
                    'askerli-celik-kalip-sistemi'
                ],
                img: ['1', '2', '3', '4', '5','6','7','8','9','10','11'],
            }
        ]
    },
]
